/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Box, Chip, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useAuthContext } from '../auth/AuthContext';
import { useAlert } from '../context/AlertContext';
import ConfirmOptoutDialog from '../components/auth/ConfrimOptoutDialog';

function UserProfile() {
  const { currentUser, loading } = useAuthContext();
  //const [jamaspUser, setJamaspUser] = useState(null);
  //const [fitbitProfile, setFitbitProfile] = React.useState({});
  const { addAlert} = useAlert();
  // User devices
  const [userDevices, setUserDevices] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  useEffect(() => {
    console.log('UserProfile useEffect user', currentUser, loading)
    if (currentUser && !loading) {
      setIsLoading(true);
      try {
        console.log("user devices: %o , dialogOpen: %o", userDevices, dialogOpen);
        addAlert('success', 'Just Testing');
        if(userDevices?.length>100)
          setUserDevices([]);

      } catch (err) {
        console.error("Error fetching user data", err);
      }
      // fetchFitBitUser(user.uid).then((usr) => {
      //   let jUser = usr[0];
      //   //console.log('UserProfile fetchFitBitUser', jUser , jUser.fitbitData);
      //   setJamaspUser(jUser);
      //   try {
      //     axios.get('https://api.fitbit.com/1/user/-/profile.json', {
      //       headers: {
      //         Authorization: `Bearer ${jUser.fitbitData.access_token}`
      //       }
      //     }).then((result) => {
      //       if (result.status === 200 && result?.data?.user) {
      //         console.log(result.data.user);
      //         // update the user profile
      //         setFitbitProfile(result.data.user);
      //         axios.get('https://api.fitbit.com/1/user/-/devices.json', {
      //           headers: {
      //             Authorization: `Bearer ${jUser.fitbitData.access_token}`
      //           }
      //         }).then((result) => {
      //           if (result.status === 200 && result?.data) {
      //             console.log(result.data);
      //             // update the user profile
      //             setUserDevices(result.data);
      //           }
      //         }).catch((error) => {
      //           console.log(error);
      //         });
      //       }
      //     }).catch((error) => {
      //       console.log(error);
      //     }
      //     );
      //   } catch (err) {
      //     console.log(err);
      //   }
      // }).catch((error) => {
      //   console.log(error);
      //   //setAlert({ type: 'error', message: error.message });
      // });
      setIsLoading(false);
    }
  }, [addAlert, currentUser, dialogOpen, loading, userDevices]);

  const handleConfirmDialogOutput = (value) => {
    console.log("handleDialogClose", value);
    //setAlert(null);
    if (value) {
      // TODO: Opt out of research
    }
    setDialogOpen(false);
  };

  return (
    <Box sx={{ mt: 5, m: 1 }}>
      {loading && (
        // TODO: Create a loading component, use it here and in other places
        <Typography>Loading...</Typography>
      )}
      {!loading && (
        <>
          <Typography variant='h4'>User Profile</Typography>
          <Typography variant='body1' component='div'>
            Email: <Chip label={currentUser.email}></Chip>
          </Typography>
          {isLoading && (
            <Typography variant='body1' component='div'>
              Loading...
            </Typography>
          )}
          <ConfirmOptoutDialog
            withButton={true}
            buttonText="Opt out of research"
            buttonColor="error"
            handleClose={handleConfirmDialogOutput}
          />

        </>
      )}
    </Box>

  );

}
export default UserProfile;